import { DEFAULT_LOCALE } from './i18n';

// The backend stores a country as a free-text English name, so that name is the option value.
const STORED_NAME_LOCALE = 'en';

// ISO codes → dropdown options, sorted by the localised label.
export const buildCountryOptions = (codes, locale = DEFAULT_LOCALE) => {
  const storedNames = new Intl.DisplayNames([STORED_NAME_LOCALE], { type: 'region' });
  const labels = new Intl.DisplayNames([locale], { type: 'region' });
  return codes
    .map((code) => ({ value: storedNames.of(code) ?? code, label: labels.of(code) ?? code }))
    .sort((a, b) => a.label.localeCompare(b.label, locale));
};

const displayNamesByLocale = new Map();

const regionNames = (locale) => {
  if (!displayNamesByLocale.has(locale)) {
    displayNamesByLocale.set(locale, new Intl.DisplayNames([locale], { type: 'region' }));
  }
  return displayNamesByLocale.get(locale);
};

export const countryCodeLabel = (code, locale = DEFAULT_LOCALE) =>
  code ? (regionNames(locale).of(code) ?? code) : null;

export const buildCountryCodeOptions = (codes, locale = DEFAULT_LOCALE) => {
  const labels = new Intl.DisplayNames([locale], { type: 'region' });
  return codes
    .map((code) => ({ value: code, label: labels.of(code) ?? code }))
    .sort((a, b) => a.label.localeCompare(b.label, locale));
};
